/** Detail page for one tuning evaluation run (guideline snapshot + metrics). */
export function buildTuningRunDetailPath(sessionId: string, runId: string): string {
  return `/accuracy/tuning/${encodeURIComponent(sessionId)}/runs/${encodeURIComponent(runId)}`;
}
